import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { BreadcrumbService } from '../shared/breadcrumb-service/breadcrumb.service';

@Component({
    selector: 'sample-tracking-report-loader',
    template: require('./sample-tracking-report-loader.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingReportsLoaderComponent implements OnInit {

    constructor(public breadCrumbService: BreadcrumbService) {
    }

    public ngOnInit() {
        
    }
}